
import * as F from 'tsui/Form';

export function convertProductData(evt: F.InputFormEvent) {

    let productData: any = { productPrice: [] };


    if (evt.data.amount_amd) {
        productData.productPrice.push({
            currency: 'AMD',
            currencyCode: '051',
            amount: parseFloat(evt.data.amount_amd),
        })

    }

    if (evt.data.amount_rub) {
        productData.productPrice.push({
            currency: 'USD',
            currencyCode: '840',
            amount: parseFloat(evt.data.amount_rub),
        })

    }

    if (evt.data.amount_usd) {
        productData.productPrice.push({
            currency: 'RUB',
            currencyCode: '643',
            amount: parseFloat(evt.data.amount_usd),
        })

    }

    // if (evt.data.profileImage) {
    //     cardData.fields.push({
    //         type: 'image',
    //         field: 'profileImage',
    //         imageUrl: evt.data.profileImage,
    //     })

    // }

    // if (evt.data.profession) {
    //     cardData.fields.push({
    //         type: 'text',
    //         field: 'profession',
    //         text: evt.data.profession,
    //     })

    // }

    // if (evt.data.location) {
    //     cardData.fields.push({
    //         type: 'text',
    //         field: 'location',
    //         text: evt.data.location,
    //     })

    // }

    // if (evt.data.position) {
    //     cardData.fields.push({
    //         type: 'text',
    //         field: 'position',
    //         text: evt.data.position,
    //     })

    // }

    // if (evt.data.email) {
    //     cardData.fields.push({
    //         type: 'text',
    //         field: 'email',
    //         text: evt.data.email,
    //     })

    // }

    // if (evt.data.phoneNumber) {
    //     cardData.fields.push({
    //         type: 'phone',
    //         field: 'phoneNumber',
    //         text: evt.data.phoneNumber,
    //     })

    // }


    // if (evt.data.workingTime) {
    //     cardData.fields.push({
    //         type: 'text',
    //         field: 'workingTime',
    //         text: evt.data.workingTime,
    //     })

    // }

    // if (evt.data.locationIcon) {
    //     cardData.fields.push({
    //         type: 'icon',
    //         field: 'locationIcon',
    //         link: evt.data.locationIcon,
    //     })

    // }

    // if (!evt.data.locationIcon) {
    //     cardData.fields.push({
    //         type: 'icon',
    //         field: 'locationIcon',
    //         link: '',
    //     })

    // }


    // if (evt.data.ministryWebsite) {
    //     cardData.fields.push({
    //         type: 'link',
    //         field: 'ministryWebsite',
    //         link: evt.data.ministryWebsite,
    //     })

    // }

    // if (evt.data.location) {
    //     cardData.fields.push({
    //         type: 'text',
    //         field: 'ministryAddress',
    //         text: evt.data.location,
    //     })

    // }

    // if (evt.data.locationIcon) {
    //     cardData.fields.push({
    //         type: 'link',
    //         field: 'ministryAddress',
    //         link: evt.data.locationIcon,
    //     })

    // }

    // if (evt.data.ministry) {
    //     cardData.fields.push({
    //         type: 'text',
    //         field: 'ministry',
    //         text: evt.data.ministry,
    //     })

    // }

    // // if (evt.data.templateVersion) {
    // //     cardData.templateVersion.push(templateName)
    // // }

    // if (evt.data.facebook) {
    //     cardData.fields.push({
    //         type: 'link',
    //         field: 'facebook',
    //         link: evt.data.facebook,
    //     })

    // }

    // if (evt.data.instagram) {
    //     cardData.fields.push({
    //         type: 'link',
    //         field: 'instagram',
    //         link: evt.data.instagram,
    //     })

    // }

    // if (evt.data.linkedIn) {
    //     cardData.fields.push({
    //         type: 'link',
    //         field: 'linkedIn',
    //         link: evt.data.linkedIn,
    //     })

    // }

    return productData;
}